import {
  LoadTimesheetsRequestAction,
  LoadTimesheetsSuccessAction,
  LoadTimesheetsErrorAction,
  ProcessActionRequestAction,
  LoadTimesheetItemRequestAction,
  LoadTimesheetItemSuccessAction,
  LoadTimesheetItemErrorAction,
  ChangeEditHoursModalVisibilityAction,
  MoveTimesheetToResolvedAction,
  ProcessActionSuccessAction,
  ProcessActionErrorAction,
} from './actions.d';
import actionsTypes from './actionTypes';
import {
  ILoadDataRequestPayload,
  ILoadDataSuccessPayload,
  ILoadItemSuccessPayload,
  ILoadTimesheetItemPayload,
  IMoveTimesheetToResolvedPayload,
  IProcessRequestPayload,
} from './types.d';

const actions = {
  loadTimesheetsRequest: <T1, T2>(payload: ILoadDataRequestPayload<T1, T2>): LoadTimesheetsRequestAction<T1, T2> => ({
    type: actionsTypes.LOAD_TIMESHEETS_REQUEST,
    payload,
  }),

  loadTimesheetsSuccess: (payload: ILoadDataSuccessPayload): LoadTimesheetsSuccessAction => ({
    type: actionsTypes.LOAD_TIMESHEETS_SUCCESS,
    payload,
  }),

  loadTimesheetsError: (): LoadTimesheetsErrorAction => ({
    type: actionsTypes.LOAD_TIMESHEETS_ERROR,
  }),

  processActionRequest: <T1, T2>(payload: IProcessRequestPayload<T1, T2>): ProcessActionRequestAction<T1, T2> => ({
    type: actionsTypes.PROCESS_ACTION_REQUEST,
    payload,
  }),

  processActionSuccess: (payload: ILoadItemSuccessPayload): ProcessActionSuccessAction => ({
    type: actionsTypes.PROCESS_ACTION_SUCCESS,
    payload,
  }),

  processActionError: (): ProcessActionErrorAction => ({
    type: actionsTypes.PROCESS_ACTION_ERROR,
  }),

  loadTimesheetItemRequest: <T1, T2>(
    payload: ILoadTimesheetItemPayload<T1, T2>,
  ): LoadTimesheetItemRequestAction<T1, T2> => ({
    type: actionsTypes.LOAD_TIMESHEET_ITEM_REQUEST,
    payload,
  }),

  loadTimesheetItemSuccess: (payload: ILoadItemSuccessPayload): LoadTimesheetItemSuccessAction => ({
    type: actionsTypes.LOAD_TIMESHEET_ITEM_SUCCESS,
    payload,
  }),

  loadTimesheetItemError: (): LoadTimesheetItemErrorAction => ({
    type: actionsTypes.LOAD_TIMESHEET_ITEM_ERROR,
  }),

  moveTimesheetToResolved: (payload: IMoveTimesheetToResolvedPayload): MoveTimesheetToResolvedAction => ({
    type: actionsTypes.MOVE_TIMESHEET_TO_RESOLVED,
    payload,
  }),

  changeEditHoursModalVisibility: (): ChangeEditHoursModalVisibilityAction => ({
    type: actionsTypes.CHANGE_EDIT_HOURS_MODAL_VISIBILITY,
  }),
};

export default actions;
